import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3c359ed5 = () => interopDefault(import('../src/pages/about.vue' /* webpackChunkName: "pages/about" */))
const _703f5ecb = () => interopDefault(import('../src/pages/ai-scriptwriter.vue' /* webpackChunkName: "pages/ai-scriptwriter" */))
const _1bb97fc6 = () => interopDefault(import('../src/pages/audiosearch.vue' /* webpackChunkName: "pages/audiosearch" */))
const _4c1d05f1 = () => interopDefault(import('../src/pages/begin.vue' /* webpackChunkName: "pages/begin" */))
const _5d2239cf = () => interopDefault(import('../src/pages/brand.vue' /* webpackChunkName: "pages/brand" */))
const _26e42ba9 = () => interopDefault(import('../src/pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _7d5cc9aa = () => interopDefault(import('../src/pages/call-for-submission/index.vue' /* webpackChunkName: "pages/call-for-submission/index" */))
const _4817ba3a = () => interopDefault(import('../src/pages/contributors/index.vue' /* webpackChunkName: "pages/contributors/index" */))
const _6c333fad = () => interopDefault(import('../src/pages/corporate.vue' /* webpackChunkName: "pages/corporate" */))
const _5bed799a = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _7d4b29c4 = () => interopDefault(import('../src/pages/legal/index.vue' /* webpackChunkName: "pages/legal/index" */))
const _41bf0cee = () => interopDefault(import('../src/pages/license.vue' /* webpackChunkName: "pages/license" */))
const _62354a8e = () => interopDefault(import('../src/pages/pricing.vue' /* webpackChunkName: "pages/pricing" */))
const _f58e870c = () => interopDefault(import('../src/pages/product/index.vue' /* webpackChunkName: "pages/product/index" */))
const _23763285 = () => interopDefault(import('../src/pages/referral.vue' /* webpackChunkName: "pages/referral" */))
const _b337cbdc = () => interopDefault(import('../src/pages/subscribe.vue' /* webpackChunkName: "pages/subscribe" */))
const _2b7460fa = () => interopDefault(import('../src/pages/test.vue' /* webpackChunkName: "pages/test" */))
const _6d77ae50 = () => interopDefault(import('../src/pages/visualsearch.vue' /* webpackChunkName: "pages/visualsearch" */))
const _1771e9bc = () => interopDefault(import('../src/pages/agreements/_id.vue' /* webpackChunkName: "pages/agreements/_id" */))
const _6b4a651c = () => interopDefault(import('../src/pages/call-for-submission/_channel.vue' /* webpackChunkName: "pages/call-for-submission/_channel" */))
const _7779cfba = () => interopDefault(import('../src/pages/campaign/_id.vue' /* webpackChunkName: "pages/campaign/_id" */))
const _65f36646 = () => interopDefault(import('../src/pages/contributors/_username.vue' /* webpackChunkName: "pages/contributors/_username" */))
const _56a3664f = () => interopDefault(import('../src/pages/free/_channel.vue' /* webpackChunkName: "pages/free/_channel" */))
const _50d5b26c = () => interopDefault(import('../src/pages/legal/_document.vue' /* webpackChunkName: "pages/legal/_document" */))
const _f8fbc99c = () => interopDefault(import('../src/pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _da9721a8 = () => interopDefault(import('../src/pages/_channel.vue' /* webpackChunkName: "pages/_channel" */))
const _c6915b98 = () => interopDefault(import('../src/pages/_mediaType/categories.vue' /* webpackChunkName: "pages/_mediaType/categories" */))
const _4f2240d5 = () => interopDefault(import('../src/pages/_mediaType/_id/index.vue' /* webpackChunkName: "pages/_mediaType/_id/index" */))
const _fe200ab0 = () => interopDefault(import('../src/pages/_mediaType/_id/_productName.vue' /* webpackChunkName: "pages/_mediaType/_id/_productName" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _3c359ed5,
    name: "about___en"
  }, {
    path: "/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___en"
  }, {
    path: "/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___en"
  }, {
    path: "/begin",
    component: _4c1d05f1,
    name: "begin___en"
  }, {
    path: "/brand",
    component: _5d2239cf,
    name: "brand___en"
  }, {
    path: "/calendar",
    component: _26e42ba9,
    name: "calendar___en"
  }, {
    path: "/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___en"
  }, {
    path: "/contributors",
    component: _4817ba3a,
    name: "contributors___en"
  }, {
    path: "/corporate",
    component: _6c333fad,
    name: "corporate___en"
  }, {
    path: "/da",
    component: _5bed799a,
    name: "index___da"
  }, {
    path: "/de",
    component: _5bed799a,
    name: "index___de"
  }, {
    path: "/es",
    component: _5bed799a,
    name: "index___es"
  }, {
    path: "/fr",
    component: _5bed799a,
    name: "index___fr"
  }, {
    path: "/hu",
    component: _5bed799a,
    name: "index___hu"
  }, {
    path: "/it",
    component: _5bed799a,
    name: "index___it"
  }, {
    path: "/ja",
    component: _5bed799a,
    name: "index___ja"
  }, {
    path: "/ko",
    component: _5bed799a,
    name: "index___ko"
  }, {
    path: "/legal",
    component: _7d4b29c4,
    name: "legal___en"
  }, {
    path: "/license",
    component: _41bf0cee,
    name: "license___en"
  }, {
    path: "/nb",
    component: _5bed799a,
    name: "index___nb"
  }, {
    path: "/nl",
    component: _5bed799a,
    name: "index___nl"
  }, {
    path: "/pl",
    component: _5bed799a,
    name: "index___pl"
  }, {
    path: "/pricing",
    component: _62354a8e,
    name: "pricing___en"
  }, {
    path: "/product",
    component: _f58e870c,
    name: "product___en"
  }, {
    path: "/pt",
    component: _5bed799a,
    name: "index___pt"
  }, {
    path: "/referral",
    component: _23763285,
    name: "referral___en"
  }, {
    path: "/ru",
    component: _5bed799a,
    name: "index___ru"
  }, {
    path: "/subscribe",
    component: _b337cbdc,
    name: "subscribe___en"
  }, {
    path: "/sv",
    component: _5bed799a,
    name: "index___sv"
  }, {
    path: "/test",
    component: _2b7460fa,
    name: "test___en"
  }, {
    path: "/th",
    component: _5bed799a,
    name: "index___th"
  }, {
    path: "/tr",
    component: _5bed799a,
    name: "index___tr"
  }, {
    path: "/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___en"
  }, {
    path: "/zh-hans",
    component: _5bed799a,
    name: "index___zh-hans"
  }, {
    path: "/zh-hant",
    component: _5bed799a,
    name: "index___zh-hant"
  }, {
    path: "/da/about",
    component: _3c359ed5,
    name: "about___da"
  }, {
    path: "/da/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___da"
  }, {
    path: "/da/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___da"
  }, {
    path: "/da/begin",
    component: _4c1d05f1,
    name: "begin___da"
  }, {
    path: "/da/brand",
    component: _5d2239cf,
    name: "brand___da"
  }, {
    path: "/da/calendar",
    component: _26e42ba9,
    name: "calendar___da"
  }, {
    path: "/da/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___da"
  }, {
    path: "/da/contributors",
    component: _4817ba3a,
    name: "contributors___da"
  }, {
    path: "/da/corporate",
    component: _6c333fad,
    name: "corporate___da"
  }, {
    path: "/da/legal",
    component: _7d4b29c4,
    name: "legal___da"
  }, {
    path: "/da/license",
    component: _41bf0cee,
    name: "license___da"
  }, {
    path: "/da/pricing",
    component: _62354a8e,
    name: "pricing___da"
  }, {
    path: "/da/product",
    component: _f58e870c,
    name: "product___da"
  }, {
    path: "/da/referral",
    component: _23763285,
    name: "referral___da"
  }, {
    path: "/da/subscribe",
    component: _b337cbdc,
    name: "subscribe___da"
  }, {
    path: "/da/test",
    component: _2b7460fa,
    name: "test___da"
  }, {
    path: "/da/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___da"
  }, {
    path: "/de/about",
    component: _3c359ed5,
    name: "about___de"
  }, {
    path: "/de/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___de"
  }, {
    path: "/de/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___de"
  }, {
    path: "/de/begin",
    component: _4c1d05f1,
    name: "begin___de"
  }, {
    path: "/de/brand",
    component: _5d2239cf,
    name: "brand___de"
  }, {
    path: "/de/calendar",
    component: _26e42ba9,
    name: "calendar___de"
  }, {
    path: "/de/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___de"
  }, {
    path: "/de/contributors",
    component: _4817ba3a,
    name: "contributors___de"
  }, {
    path: "/de/corporate",
    component: _6c333fad,
    name: "corporate___de"
  }, {
    path: "/de/legal",
    component: _7d4b29c4,
    name: "legal___de"
  }, {
    path: "/de/license",
    component: _41bf0cee,
    name: "license___de"
  }, {
    path: "/de/pricing",
    component: _62354a8e,
    name: "pricing___de"
  }, {
    path: "/de/product",
    component: _f58e870c,
    name: "product___de"
  }, {
    path: "/de/referral",
    component: _23763285,
    name: "referral___de"
  }, {
    path: "/de/subscribe",
    component: _b337cbdc,
    name: "subscribe___de"
  }, {
    path: "/de/test",
    component: _2b7460fa,
    name: "test___de"
  }, {
    path: "/de/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___de"
  }, {
    path: "/es/about",
    component: _3c359ed5,
    name: "about___es"
  }, {
    path: "/es/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___es"
  }, {
    path: "/es/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___es"
  }, {
    path: "/es/begin",
    component: _4c1d05f1,
    name: "begin___es"
  }, {
    path: "/es/brand",
    component: _5d2239cf,
    name: "brand___es"
  }, {
    path: "/es/calendar",
    component: _26e42ba9,
    name: "calendar___es"
  }, {
    path: "/es/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___es"
  }, {
    path: "/es/contributors",
    component: _4817ba3a,
    name: "contributors___es"
  }, {
    path: "/es/corporate",
    component: _6c333fad,
    name: "corporate___es"
  }, {
    path: "/es/legal",
    component: _7d4b29c4,
    name: "legal___es"
  }, {
    path: "/es/license",
    component: _41bf0cee,
    name: "license___es"
  }, {
    path: "/es/pricing",
    component: _62354a8e,
    name: "pricing___es"
  }, {
    path: "/es/product",
    component: _f58e870c,
    name: "product___es"
  }, {
    path: "/es/referral",
    component: _23763285,
    name: "referral___es"
  }, {
    path: "/es/subscribe",
    component: _b337cbdc,
    name: "subscribe___es"
  }, {
    path: "/es/test",
    component: _2b7460fa,
    name: "test___es"
  }, {
    path: "/es/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___es"
  }, {
    path: "/fr/about",
    component: _3c359ed5,
    name: "about___fr"
  }, {
    path: "/fr/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___fr"
  }, {
    path: "/fr/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___fr"
  }, {
    path: "/fr/begin",
    component: _4c1d05f1,
    name: "begin___fr"
  }, {
    path: "/fr/brand",
    component: _5d2239cf,
    name: "brand___fr"
  }, {
    path: "/fr/calendar",
    component: _26e42ba9,
    name: "calendar___fr"
  }, {
    path: "/fr/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___fr"
  }, {
    path: "/fr/contributors",
    component: _4817ba3a,
    name: "contributors___fr"
  }, {
    path: "/fr/corporate",
    component: _6c333fad,
    name: "corporate___fr"
  }, {
    path: "/fr/legal",
    component: _7d4b29c4,
    name: "legal___fr"
  }, {
    path: "/fr/license",
    component: _41bf0cee,
    name: "license___fr"
  }, {
    path: "/fr/pricing",
    component: _62354a8e,
    name: "pricing___fr"
  }, {
    path: "/fr/product",
    component: _f58e870c,
    name: "product___fr"
  }, {
    path: "/fr/referral",
    component: _23763285,
    name: "referral___fr"
  }, {
    path: "/fr/subscribe",
    component: _b337cbdc,
    name: "subscribe___fr"
  }, {
    path: "/fr/test",
    component: _2b7460fa,
    name: "test___fr"
  }, {
    path: "/fr/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___fr"
  }, {
    path: "/hu/about",
    component: _3c359ed5,
    name: "about___hu"
  }, {
    path: "/hu/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___hu"
  }, {
    path: "/hu/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___hu"
  }, {
    path: "/hu/begin",
    component: _4c1d05f1,
    name: "begin___hu"
  }, {
    path: "/hu/brand",
    component: _5d2239cf,
    name: "brand___hu"
  }, {
    path: "/hu/calendar",
    component: _26e42ba9,
    name: "calendar___hu"
  }, {
    path: "/hu/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___hu"
  }, {
    path: "/hu/contributors",
    component: _4817ba3a,
    name: "contributors___hu"
  }, {
    path: "/hu/corporate",
    component: _6c333fad,
    name: "corporate___hu"
  }, {
    path: "/hu/legal",
    component: _7d4b29c4,
    name: "legal___hu"
  }, {
    path: "/hu/license",
    component: _41bf0cee,
    name: "license___hu"
  }, {
    path: "/hu/pricing",
    component: _62354a8e,
    name: "pricing___hu"
  }, {
    path: "/hu/product",
    component: _f58e870c,
    name: "product___hu"
  }, {
    path: "/hu/referral",
    component: _23763285,
    name: "referral___hu"
  }, {
    path: "/hu/subscribe",
    component: _b337cbdc,
    name: "subscribe___hu"
  }, {
    path: "/hu/test",
    component: _2b7460fa,
    name: "test___hu"
  }, {
    path: "/hu/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___hu"
  }, {
    path: "/it/about",
    component: _3c359ed5,
    name: "about___it"
  }, {
    path: "/it/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___it"
  }, {
    path: "/it/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___it"
  }, {
    path: "/it/begin",
    component: _4c1d05f1,
    name: "begin___it"
  }, {
    path: "/it/brand",
    component: _5d2239cf,
    name: "brand___it"
  }, {
    path: "/it/calendar",
    component: _26e42ba9,
    name: "calendar___it"
  }, {
    path: "/it/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___it"
  }, {
    path: "/it/contributors",
    component: _4817ba3a,
    name: "contributors___it"
  }, {
    path: "/it/corporate",
    component: _6c333fad,
    name: "corporate___it"
  }, {
    path: "/it/legal",
    component: _7d4b29c4,
    name: "legal___it"
  }, {
    path: "/it/license",
    component: _41bf0cee,
    name: "license___it"
  }, {
    path: "/it/pricing",
    component: _62354a8e,
    name: "pricing___it"
  }, {
    path: "/it/product",
    component: _f58e870c,
    name: "product___it"
  }, {
    path: "/it/referral",
    component: _23763285,
    name: "referral___it"
  }, {
    path: "/it/subscribe",
    component: _b337cbdc,
    name: "subscribe___it"
  }, {
    path: "/it/test",
    component: _2b7460fa,
    name: "test___it"
  }, {
    path: "/it/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___it"
  }, {
    path: "/ja/about",
    component: _3c359ed5,
    name: "about___ja"
  }, {
    path: "/ja/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___ja"
  }, {
    path: "/ja/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___ja"
  }, {
    path: "/ja/begin",
    component: _4c1d05f1,
    name: "begin___ja"
  }, {
    path: "/ja/brand",
    component: _5d2239cf,
    name: "brand___ja"
  }, {
    path: "/ja/calendar",
    component: _26e42ba9,
    name: "calendar___ja"
  }, {
    path: "/ja/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___ja"
  }, {
    path: "/ja/contributors",
    component: _4817ba3a,
    name: "contributors___ja"
  }, {
    path: "/ja/corporate",
    component: _6c333fad,
    name: "corporate___ja"
  }, {
    path: "/ja/legal",
    component: _7d4b29c4,
    name: "legal___ja"
  }, {
    path: "/ja/license",
    component: _41bf0cee,
    name: "license___ja"
  }, {
    path: "/ja/pricing",
    component: _62354a8e,
    name: "pricing___ja"
  }, {
    path: "/ja/product",
    component: _f58e870c,
    name: "product___ja"
  }, {
    path: "/ja/referral",
    component: _23763285,
    name: "referral___ja"
  }, {
    path: "/ja/subscribe",
    component: _b337cbdc,
    name: "subscribe___ja"
  }, {
    path: "/ja/test",
    component: _2b7460fa,
    name: "test___ja"
  }, {
    path: "/ja/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___ja"
  }, {
    path: "/ko/about",
    component: _3c359ed5,
    name: "about___ko"
  }, {
    path: "/ko/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___ko"
  }, {
    path: "/ko/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___ko"
  }, {
    path: "/ko/begin",
    component: _4c1d05f1,
    name: "begin___ko"
  }, {
    path: "/ko/brand",
    component: _5d2239cf,
    name: "brand___ko"
  }, {
    path: "/ko/calendar",
    component: _26e42ba9,
    name: "calendar___ko"
  }, {
    path: "/ko/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___ko"
  }, {
    path: "/ko/contributors",
    component: _4817ba3a,
    name: "contributors___ko"
  }, {
    path: "/ko/corporate",
    component: _6c333fad,
    name: "corporate___ko"
  }, {
    path: "/ko/legal",
    component: _7d4b29c4,
    name: "legal___ko"
  }, {
    path: "/ko/license",
    component: _41bf0cee,
    name: "license___ko"
  }, {
    path: "/ko/pricing",
    component: _62354a8e,
    name: "pricing___ko"
  }, {
    path: "/ko/product",
    component: _f58e870c,
    name: "product___ko"
  }, {
    path: "/ko/referral",
    component: _23763285,
    name: "referral___ko"
  }, {
    path: "/ko/subscribe",
    component: _b337cbdc,
    name: "subscribe___ko"
  }, {
    path: "/ko/test",
    component: _2b7460fa,
    name: "test___ko"
  }, {
    path: "/ko/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___ko"
  }, {
    path: "/nb/about",
    component: _3c359ed5,
    name: "about___nb"
  }, {
    path: "/nb/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___nb"
  }, {
    path: "/nb/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___nb"
  }, {
    path: "/nb/begin",
    component: _4c1d05f1,
    name: "begin___nb"
  }, {
    path: "/nb/brand",
    component: _5d2239cf,
    name: "brand___nb"
  }, {
    path: "/nb/calendar",
    component: _26e42ba9,
    name: "calendar___nb"
  }, {
    path: "/nb/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___nb"
  }, {
    path: "/nb/contributors",
    component: _4817ba3a,
    name: "contributors___nb"
  }, {
    path: "/nb/corporate",
    component: _6c333fad,
    name: "corporate___nb"
  }, {
    path: "/nb/legal",
    component: _7d4b29c4,
    name: "legal___nb"
  }, {
    path: "/nb/license",
    component: _41bf0cee,
    name: "license___nb"
  }, {
    path: "/nb/pricing",
    component: _62354a8e,
    name: "pricing___nb"
  }, {
    path: "/nb/product",
    component: _f58e870c,
    name: "product___nb"
  }, {
    path: "/nb/referral",
    component: _23763285,
    name: "referral___nb"
  }, {
    path: "/nb/subscribe",
    component: _b337cbdc,
    name: "subscribe___nb"
  }, {
    path: "/nb/test",
    component: _2b7460fa,
    name: "test___nb"
  }, {
    path: "/nb/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___nb"
  }, {
    path: "/nl/about",
    component: _3c359ed5,
    name: "about___nl"
  }, {
    path: "/nl/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___nl"
  }, {
    path: "/nl/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___nl"
  }, {
    path: "/nl/begin",
    component: _4c1d05f1,
    name: "begin___nl"
  }, {
    path: "/nl/brand",
    component: _5d2239cf,
    name: "brand___nl"
  }, {
    path: "/nl/calendar",
    component: _26e42ba9,
    name: "calendar___nl"
  }, {
    path: "/nl/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___nl"
  }, {
    path: "/nl/contributors",
    component: _4817ba3a,
    name: "contributors___nl"
  }, {
    path: "/nl/corporate",
    component: _6c333fad,
    name: "corporate___nl"
  }, {
    path: "/nl/legal",
    component: _7d4b29c4,
    name: "legal___nl"
  }, {
    path: "/nl/license",
    component: _41bf0cee,
    name: "license___nl"
  }, {
    path: "/nl/pricing",
    component: _62354a8e,
    name: "pricing___nl"
  }, {
    path: "/nl/product",
    component: _f58e870c,
    name: "product___nl"
  }, {
    path: "/nl/referral",
    component: _23763285,
    name: "referral___nl"
  }, {
    path: "/nl/subscribe",
    component: _b337cbdc,
    name: "subscribe___nl"
  }, {
    path: "/nl/test",
    component: _2b7460fa,
    name: "test___nl"
  }, {
    path: "/nl/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___nl"
  }, {
    path: "/pl/about",
    component: _3c359ed5,
    name: "about___pl"
  }, {
    path: "/pl/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___pl"
  }, {
    path: "/pl/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___pl"
  }, {
    path: "/pl/begin",
    component: _4c1d05f1,
    name: "begin___pl"
  }, {
    path: "/pl/brand",
    component: _5d2239cf,
    name: "brand___pl"
  }, {
    path: "/pl/calendar",
    component: _26e42ba9,
    name: "calendar___pl"
  }, {
    path: "/pl/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___pl"
  }, {
    path: "/pl/contributors",
    component: _4817ba3a,
    name: "contributors___pl"
  }, {
    path: "/pl/corporate",
    component: _6c333fad,
    name: "corporate___pl"
  }, {
    path: "/pl/legal",
    component: _7d4b29c4,
    name: "legal___pl"
  }, {
    path: "/pl/license",
    component: _41bf0cee,
    name: "license___pl"
  }, {
    path: "/pl/pricing",
    component: _62354a8e,
    name: "pricing___pl"
  }, {
    path: "/pl/product",
    component: _f58e870c,
    name: "product___pl"
  }, {
    path: "/pl/referral",
    component: _23763285,
    name: "referral___pl"
  }, {
    path: "/pl/subscribe",
    component: _b337cbdc,
    name: "subscribe___pl"
  }, {
    path: "/pl/test",
    component: _2b7460fa,
    name: "test___pl"
  }, {
    path: "/pl/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___pl"
  }, {
    path: "/pt/about",
    component: _3c359ed5,
    name: "about___pt"
  }, {
    path: "/pt/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___pt"
  }, {
    path: "/pt/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___pt"
  }, {
    path: "/pt/begin",
    component: _4c1d05f1,
    name: "begin___pt"
  }, {
    path: "/pt/brand",
    component: _5d2239cf,
    name: "brand___pt"
  }, {
    path: "/pt/calendar",
    component: _26e42ba9,
    name: "calendar___pt"
  }, {
    path: "/pt/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___pt"
  }, {
    path: "/pt/contributors",
    component: _4817ba3a,
    name: "contributors___pt"
  }, {
    path: "/pt/corporate",
    component: _6c333fad,
    name: "corporate___pt"
  }, {
    path: "/pt/legal",
    component: _7d4b29c4,
    name: "legal___pt"
  }, {
    path: "/pt/license",
    component: _41bf0cee,
    name: "license___pt"
  }, {
    path: "/pt/pricing",
    component: _62354a8e,
    name: "pricing___pt"
  }, {
    path: "/pt/product",
    component: _f58e870c,
    name: "product___pt"
  }, {
    path: "/pt/referral",
    component: _23763285,
    name: "referral___pt"
  }, {
    path: "/pt/subscribe",
    component: _b337cbdc,
    name: "subscribe___pt"
  }, {
    path: "/pt/test",
    component: _2b7460fa,
    name: "test___pt"
  }, {
    path: "/pt/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___pt"
  }, {
    path: "/ru/about",
    component: _3c359ed5,
    name: "about___ru"
  }, {
    path: "/ru/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___ru"
  }, {
    path: "/ru/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___ru"
  }, {
    path: "/ru/begin",
    component: _4c1d05f1,
    name: "begin___ru"
  }, {
    path: "/ru/brand",
    component: _5d2239cf,
    name: "brand___ru"
  }, {
    path: "/ru/calendar",
    component: _26e42ba9,
    name: "calendar___ru"
  }, {
    path: "/ru/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___ru"
  }, {
    path: "/ru/contributors",
    component: _4817ba3a,
    name: "contributors___ru"
  }, {
    path: "/ru/corporate",
    component: _6c333fad,
    name: "corporate___ru"
  }, {
    path: "/ru/legal",
    component: _7d4b29c4,
    name: "legal___ru"
  }, {
    path: "/ru/license",
    component: _41bf0cee,
    name: "license___ru"
  }, {
    path: "/ru/pricing",
    component: _62354a8e,
    name: "pricing___ru"
  }, {
    path: "/ru/product",
    component: _f58e870c,
    name: "product___ru"
  }, {
    path: "/ru/referral",
    component: _23763285,
    name: "referral___ru"
  }, {
    path: "/ru/subscribe",
    component: _b337cbdc,
    name: "subscribe___ru"
  }, {
    path: "/ru/test",
    component: _2b7460fa,
    name: "test___ru"
  }, {
    path: "/ru/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___ru"
  }, {
    path: "/sv/about",
    component: _3c359ed5,
    name: "about___sv"
  }, {
    path: "/sv/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___sv"
  }, {
    path: "/sv/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___sv"
  }, {
    path: "/sv/begin",
    component: _4c1d05f1,
    name: "begin___sv"
  }, {
    path: "/sv/brand",
    component: _5d2239cf,
    name: "brand___sv"
  }, {
    path: "/sv/calendar",
    component: _26e42ba9,
    name: "calendar___sv"
  }, {
    path: "/sv/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___sv"
  }, {
    path: "/sv/contributors",
    component: _4817ba3a,
    name: "contributors___sv"
  }, {
    path: "/sv/corporate",
    component: _6c333fad,
    name: "corporate___sv"
  }, {
    path: "/sv/legal",
    component: _7d4b29c4,
    name: "legal___sv"
  }, {
    path: "/sv/license",
    component: _41bf0cee,
    name: "license___sv"
  }, {
    path: "/sv/pricing",
    component: _62354a8e,
    name: "pricing___sv"
  }, {
    path: "/sv/product",
    component: _f58e870c,
    name: "product___sv"
  }, {
    path: "/sv/referral",
    component: _23763285,
    name: "referral___sv"
  }, {
    path: "/sv/subscribe",
    component: _b337cbdc,
    name: "subscribe___sv"
  }, {
    path: "/sv/test",
    component: _2b7460fa,
    name: "test___sv"
  }, {
    path: "/sv/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___sv"
  }, {
    path: "/th/about",
    component: _3c359ed5,
    name: "about___th"
  }, {
    path: "/th/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___th"
  }, {
    path: "/th/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___th"
  }, {
    path: "/th/begin",
    component: _4c1d05f1,
    name: "begin___th"
  }, {
    path: "/th/brand",
    component: _5d2239cf,
    name: "brand___th"
  }, {
    path: "/th/calendar",
    component: _26e42ba9,
    name: "calendar___th"
  }, {
    path: "/th/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___th"
  }, {
    path: "/th/contributors",
    component: _4817ba3a,
    name: "contributors___th"
  }, {
    path: "/th/corporate",
    component: _6c333fad,
    name: "corporate___th"
  }, {
    path: "/th/legal",
    component: _7d4b29c4,
    name: "legal___th"
  }, {
    path: "/th/license",
    component: _41bf0cee,
    name: "license___th"
  }, {
    path: "/th/pricing",
    component: _62354a8e,
    name: "pricing___th"
  }, {
    path: "/th/product",
    component: _f58e870c,
    name: "product___th"
  }, {
    path: "/th/referral",
    component: _23763285,
    name: "referral___th"
  }, {
    path: "/th/subscribe",
    component: _b337cbdc,
    name: "subscribe___th"
  }, {
    path: "/th/test",
    component: _2b7460fa,
    name: "test___th"
  }, {
    path: "/th/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___th"
  }, {
    path: "/tr/about",
    component: _3c359ed5,
    name: "about___tr"
  }, {
    path: "/tr/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___tr"
  }, {
    path: "/tr/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___tr"
  }, {
    path: "/tr/begin",
    component: _4c1d05f1,
    name: "begin___tr"
  }, {
    path: "/tr/brand",
    component: _5d2239cf,
    name: "brand___tr"
  }, {
    path: "/tr/calendar",
    component: _26e42ba9,
    name: "calendar___tr"
  }, {
    path: "/tr/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___tr"
  }, {
    path: "/tr/contributors",
    component: _4817ba3a,
    name: "contributors___tr"
  }, {
    path: "/tr/corporate",
    component: _6c333fad,
    name: "corporate___tr"
  }, {
    path: "/tr/legal",
    component: _7d4b29c4,
    name: "legal___tr"
  }, {
    path: "/tr/license",
    component: _41bf0cee,
    name: "license___tr"
  }, {
    path: "/tr/pricing",
    component: _62354a8e,
    name: "pricing___tr"
  }, {
    path: "/tr/product",
    component: _f58e870c,
    name: "product___tr"
  }, {
    path: "/tr/referral",
    component: _23763285,
    name: "referral___tr"
  }, {
    path: "/tr/subscribe",
    component: _b337cbdc,
    name: "subscribe___tr"
  }, {
    path: "/tr/test",
    component: _2b7460fa,
    name: "test___tr"
  }, {
    path: "/tr/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___tr"
  }, {
    path: "/zh-hans/about",
    component: _3c359ed5,
    name: "about___zh-hans"
  }, {
    path: "/zh-hans/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___zh-hans"
  }, {
    path: "/zh-hans/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___zh-hans"
  }, {
    path: "/zh-hans/begin",
    component: _4c1d05f1,
    name: "begin___zh-hans"
  }, {
    path: "/zh-hans/brand",
    component: _5d2239cf,
    name: "brand___zh-hans"
  }, {
    path: "/zh-hans/calendar",
    component: _26e42ba9,
    name: "calendar___zh-hans"
  }, {
    path: "/zh-hans/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___zh-hans"
  }, {
    path: "/zh-hans/contributors",
    component: _4817ba3a,
    name: "contributors___zh-hans"
  }, {
    path: "/zh-hans/corporate",
    component: _6c333fad,
    name: "corporate___zh-hans"
  }, {
    path: "/zh-hans/legal",
    component: _7d4b29c4,
    name: "legal___zh-hans"
  }, {
    path: "/zh-hans/license",
    component: _41bf0cee,
    name: "license___zh-hans"
  }, {
    path: "/zh-hans/pricing",
    component: _62354a8e,
    name: "pricing___zh-hans"
  }, {
    path: "/zh-hans/product",
    component: _f58e870c,
    name: "product___zh-hans"
  }, {
    path: "/zh-hans/referral",
    component: _23763285,
    name: "referral___zh-hans"
  }, {
    path: "/zh-hans/subscribe",
    component: _b337cbdc,
    name: "subscribe___zh-hans"
  }, {
    path: "/zh-hans/test",
    component: _2b7460fa,
    name: "test___zh-hans"
  }, {
    path: "/zh-hans/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___zh-hans"
  }, {
    path: "/zh-hant/about",
    component: _3c359ed5,
    name: "about___zh-hant"
  }, {
    path: "/zh-hant/ai-scriptwriter",
    component: _703f5ecb,
    name: "ai-scriptwriter___zh-hant"
  }, {
    path: "/zh-hant/audiosearch",
    component: _1bb97fc6,
    name: "audiosearch___zh-hant"
  }, {
    path: "/zh-hant/begin",
    component: _4c1d05f1,
    name: "begin___zh-hant"
  }, {
    path: "/zh-hant/brand",
    component: _5d2239cf,
    name: "brand___zh-hant"
  }, {
    path: "/zh-hant/calendar",
    component: _26e42ba9,
    name: "calendar___zh-hant"
  }, {
    path: "/zh-hant/call-for-submission",
    component: _7d5cc9aa,
    name: "call-for-submission___zh-hant"
  }, {
    path: "/zh-hant/contributors",
    component: _4817ba3a,
    name: "contributors___zh-hant"
  }, {
    path: "/zh-hant/corporate",
    component: _6c333fad,
    name: "corporate___zh-hant"
  }, {
    path: "/zh-hant/legal",
    component: _7d4b29c4,
    name: "legal___zh-hant"
  }, {
    path: "/zh-hant/license",
    component: _41bf0cee,
    name: "license___zh-hant"
  }, {
    path: "/zh-hant/pricing",
    component: _62354a8e,
    name: "pricing___zh-hant"
  }, {
    path: "/zh-hant/product",
    component: _f58e870c,
    name: "product___zh-hant"
  }, {
    path: "/zh-hant/referral",
    component: _23763285,
    name: "referral___zh-hant"
  }, {
    path: "/zh-hant/subscribe",
    component: _b337cbdc,
    name: "subscribe___zh-hant"
  }, {
    path: "/zh-hant/test",
    component: _2b7460fa,
    name: "test___zh-hant"
  }, {
    path: "/zh-hant/visualsearch",
    component: _6d77ae50,
    name: "visualsearch___zh-hant"
  }, {
    path: "/da/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___da"
  }, {
    path: "/da/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___da"
  }, {
    path: "/da/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___da"
  }, {
    path: "/da/contributors/:username",
    component: _65f36646,
    name: "contributors-username___da"
  }, {
    path: "/da/free/:channel?",
    component: _56a3664f,
    name: "free-channel___da"
  }, {
    path: "/da/legal/:document",
    component: _50d5b26c,
    name: "legal-document___da"
  }, {
    path: "/da/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___da"
  }, {
    path: "/de/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___de"
  }, {
    path: "/de/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___de"
  }, {
    path: "/de/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___de"
  }, {
    path: "/de/contributors/:username",
    component: _65f36646,
    name: "contributors-username___de"
  }, {
    path: "/de/free/:channel?",
    component: _56a3664f,
    name: "free-channel___de"
  }, {
    path: "/de/legal/:document",
    component: _50d5b26c,
    name: "legal-document___de"
  }, {
    path: "/de/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___de"
  }, {
    path: "/es/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___es"
  }, {
    path: "/es/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___es"
  }, {
    path: "/es/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___es"
  }, {
    path: "/es/contributors/:username",
    component: _65f36646,
    name: "contributors-username___es"
  }, {
    path: "/es/free/:channel?",
    component: _56a3664f,
    name: "free-channel___es"
  }, {
    path: "/es/legal/:document",
    component: _50d5b26c,
    name: "legal-document___es"
  }, {
    path: "/es/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___es"
  }, {
    path: "/fr/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___fr"
  }, {
    path: "/fr/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___fr"
  }, {
    path: "/fr/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___fr"
  }, {
    path: "/fr/contributors/:username",
    component: _65f36646,
    name: "contributors-username___fr"
  }, {
    path: "/fr/free/:channel?",
    component: _56a3664f,
    name: "free-channel___fr"
  }, {
    path: "/fr/legal/:document",
    component: _50d5b26c,
    name: "legal-document___fr"
  }, {
    path: "/fr/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___fr"
  }, {
    path: "/hu/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___hu"
  }, {
    path: "/hu/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___hu"
  }, {
    path: "/hu/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___hu"
  }, {
    path: "/hu/contributors/:username",
    component: _65f36646,
    name: "contributors-username___hu"
  }, {
    path: "/hu/free/:channel?",
    component: _56a3664f,
    name: "free-channel___hu"
  }, {
    path: "/hu/legal/:document",
    component: _50d5b26c,
    name: "legal-document___hu"
  }, {
    path: "/hu/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___hu"
  }, {
    path: "/it/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___it"
  }, {
    path: "/it/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___it"
  }, {
    path: "/it/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___it"
  }, {
    path: "/it/contributors/:username",
    component: _65f36646,
    name: "contributors-username___it"
  }, {
    path: "/it/free/:channel?",
    component: _56a3664f,
    name: "free-channel___it"
  }, {
    path: "/it/legal/:document",
    component: _50d5b26c,
    name: "legal-document___it"
  }, {
    path: "/it/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___it"
  }, {
    path: "/ja/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___ja"
  }, {
    path: "/ja/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___ja"
  }, {
    path: "/ja/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___ja"
  }, {
    path: "/ja/contributors/:username",
    component: _65f36646,
    name: "contributors-username___ja"
  }, {
    path: "/ja/free/:channel?",
    component: _56a3664f,
    name: "free-channel___ja"
  }, {
    path: "/ja/legal/:document",
    component: _50d5b26c,
    name: "legal-document___ja"
  }, {
    path: "/ja/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___ja"
  }, {
    path: "/ko/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___ko"
  }, {
    path: "/ko/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___ko"
  }, {
    path: "/ko/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___ko"
  }, {
    path: "/ko/contributors/:username",
    component: _65f36646,
    name: "contributors-username___ko"
  }, {
    path: "/ko/free/:channel?",
    component: _56a3664f,
    name: "free-channel___ko"
  }, {
    path: "/ko/legal/:document",
    component: _50d5b26c,
    name: "legal-document___ko"
  }, {
    path: "/ko/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___ko"
  }, {
    path: "/nb/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___nb"
  }, {
    path: "/nb/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___nb"
  }, {
    path: "/nb/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___nb"
  }, {
    path: "/nb/contributors/:username",
    component: _65f36646,
    name: "contributors-username___nb"
  }, {
    path: "/nb/free/:channel?",
    component: _56a3664f,
    name: "free-channel___nb"
  }, {
    path: "/nb/legal/:document",
    component: _50d5b26c,
    name: "legal-document___nb"
  }, {
    path: "/nb/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___nb"
  }, {
    path: "/nl/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___nl"
  }, {
    path: "/nl/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___nl"
  }, {
    path: "/nl/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___nl"
  }, {
    path: "/nl/contributors/:username",
    component: _65f36646,
    name: "contributors-username___nl"
  }, {
    path: "/nl/free/:channel?",
    component: _56a3664f,
    name: "free-channel___nl"
  }, {
    path: "/nl/legal/:document",
    component: _50d5b26c,
    name: "legal-document___nl"
  }, {
    path: "/nl/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___nl"
  }, {
    path: "/pl/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___pl"
  }, {
    path: "/pl/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___pl"
  }, {
    path: "/pl/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___pl"
  }, {
    path: "/pl/contributors/:username",
    component: _65f36646,
    name: "contributors-username___pl"
  }, {
    path: "/pl/free/:channel?",
    component: _56a3664f,
    name: "free-channel___pl"
  }, {
    path: "/pl/legal/:document",
    component: _50d5b26c,
    name: "legal-document___pl"
  }, {
    path: "/pl/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___pl"
  }, {
    path: "/pt/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___pt"
  }, {
    path: "/pt/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___pt"
  }, {
    path: "/pt/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___pt"
  }, {
    path: "/pt/contributors/:username",
    component: _65f36646,
    name: "contributors-username___pt"
  }, {
    path: "/pt/free/:channel?",
    component: _56a3664f,
    name: "free-channel___pt"
  }, {
    path: "/pt/legal/:document",
    component: _50d5b26c,
    name: "legal-document___pt"
  }, {
    path: "/pt/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___pt"
  }, {
    path: "/ru/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___ru"
  }, {
    path: "/ru/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___ru"
  }, {
    path: "/ru/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___ru"
  }, {
    path: "/ru/contributors/:username",
    component: _65f36646,
    name: "contributors-username___ru"
  }, {
    path: "/ru/free/:channel?",
    component: _56a3664f,
    name: "free-channel___ru"
  }, {
    path: "/ru/legal/:document",
    component: _50d5b26c,
    name: "legal-document___ru"
  }, {
    path: "/ru/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___ru"
  }, {
    path: "/sv/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___sv"
  }, {
    path: "/sv/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___sv"
  }, {
    path: "/sv/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___sv"
  }, {
    path: "/sv/contributors/:username",
    component: _65f36646,
    name: "contributors-username___sv"
  }, {
    path: "/sv/free/:channel?",
    component: _56a3664f,
    name: "free-channel___sv"
  }, {
    path: "/sv/legal/:document",
    component: _50d5b26c,
    name: "legal-document___sv"
  }, {
    path: "/sv/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___sv"
  }, {
    path: "/th/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___th"
  }, {
    path: "/th/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___th"
  }, {
    path: "/th/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___th"
  }, {
    path: "/th/contributors/:username",
    component: _65f36646,
    name: "contributors-username___th"
  }, {
    path: "/th/free/:channel?",
    component: _56a3664f,
    name: "free-channel___th"
  }, {
    path: "/th/legal/:document",
    component: _50d5b26c,
    name: "legal-document___th"
  }, {
    path: "/th/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___th"
  }, {
    path: "/tr/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___tr"
  }, {
    path: "/tr/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___tr"
  }, {
    path: "/tr/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___tr"
  }, {
    path: "/tr/contributors/:username",
    component: _65f36646,
    name: "contributors-username___tr"
  }, {
    path: "/tr/free/:channel?",
    component: _56a3664f,
    name: "free-channel___tr"
  }, {
    path: "/tr/legal/:document",
    component: _50d5b26c,
    name: "legal-document___tr"
  }, {
    path: "/tr/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___tr"
  }, {
    path: "/zh-hans/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___zh-hans"
  }, {
    path: "/zh-hans/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___zh-hans"
  }, {
    path: "/zh-hans/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___zh-hans"
  }, {
    path: "/zh-hans/contributors/:username",
    component: _65f36646,
    name: "contributors-username___zh-hans"
  }, {
    path: "/zh-hans/free/:channel?",
    component: _56a3664f,
    name: "free-channel___zh-hans"
  }, {
    path: "/zh-hans/legal/:document",
    component: _50d5b26c,
    name: "legal-document___zh-hans"
  }, {
    path: "/zh-hans/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___zh-hans"
  }, {
    path: "/zh-hant/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___zh-hant"
  }, {
    path: "/zh-hant/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___zh-hant"
  }, {
    path: "/zh-hant/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___zh-hant"
  }, {
    path: "/zh-hant/contributors/:username",
    component: _65f36646,
    name: "contributors-username___zh-hant"
  }, {
    path: "/zh-hant/free/:channel?",
    component: _56a3664f,
    name: "free-channel___zh-hant"
  }, {
    path: "/zh-hant/legal/:document",
    component: _50d5b26c,
    name: "legal-document___zh-hant"
  }, {
    path: "/zh-hant/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___zh-hant"
  }, {
    path: "/agreements/:id?",
    component: _1771e9bc,
    name: "agreements-id___en"
  }, {
    path: "/call-for-submission/:channel?",
    component: _6b4a651c,
    name: "call-for-submission-channel___en"
  }, {
    path: "/campaign/:id?",
    component: _7779cfba,
    name: "campaign-id___en"
  }, {
    path: "/contributors/:username",
    component: _65f36646,
    name: "contributors-username___en"
  }, {
    path: "/da/:channel",
    component: _da9721a8,
    name: "channel___da"
  }, {
    path: "/de/:channel",
    component: _da9721a8,
    name: "channel___de"
  }, {
    path: "/es/:channel",
    component: _da9721a8,
    name: "channel___es"
  }, {
    path: "/fr/:channel",
    component: _da9721a8,
    name: "channel___fr"
  }, {
    path: "/free/:channel?",
    component: _56a3664f,
    name: "free-channel___en"
  }, {
    path: "/hu/:channel",
    component: _da9721a8,
    name: "channel___hu"
  }, {
    path: "/it/:channel",
    component: _da9721a8,
    name: "channel___it"
  }, {
    path: "/ja/:channel",
    component: _da9721a8,
    name: "channel___ja"
  }, {
    path: "/ko/:channel",
    component: _da9721a8,
    name: "channel___ko"
  }, {
    path: "/legal/:document",
    component: _50d5b26c,
    name: "legal-document___en"
  }, {
    path: "/nb/:channel",
    component: _da9721a8,
    name: "channel___nb"
  }, {
    path: "/nl/:channel",
    component: _da9721a8,
    name: "channel___nl"
  }, {
    path: "/pl/:channel",
    component: _da9721a8,
    name: "channel___pl"
  }, {
    path: "/product/:slug",
    component: _f8fbc99c,
    name: "product-slug___en"
  }, {
    path: "/pt/:channel",
    component: _da9721a8,
    name: "channel___pt"
  }, {
    path: "/ru/:channel",
    component: _da9721a8,
    name: "channel___ru"
  }, {
    path: "/sv/:channel",
    component: _da9721a8,
    name: "channel___sv"
  }, {
    path: "/th/:channel",
    component: _da9721a8,
    name: "channel___th"
  }, {
    path: "/tr/:channel",
    component: _da9721a8,
    name: "channel___tr"
  }, {
    path: "/zh-hans/:channel",
    component: _da9721a8,
    name: "channel___zh-hans"
  }, {
    path: "/zh-hant/:channel",
    component: _da9721a8,
    name: "channel___zh-hant"
  }, {
    path: "/da/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___da"
  }, {
    path: "/de/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___de"
  }, {
    path: "/es/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___es"
  }, {
    path: "/fr/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___fr"
  }, {
    path: "/hu/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___hu"
  }, {
    path: "/it/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___it"
  }, {
    path: "/ja/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___ja"
  }, {
    path: "/ko/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___ko"
  }, {
    path: "/nb/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___nb"
  }, {
    path: "/nl/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___nl"
  }, {
    path: "/pl/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___pl"
  }, {
    path: "/pt/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___pt"
  }, {
    path: "/ru/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___ru"
  }, {
    path: "/sv/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___sv"
  }, {
    path: "/th/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___th"
  }, {
    path: "/tr/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___tr"
  }, {
    path: "/zh-hans/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___zh-hans"
  }, {
    path: "/zh-hant/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___zh-hant"
  }, {
    path: "/da/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___da"
  }, {
    path: "/de/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___de"
  }, {
    path: "/es/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___es"
  }, {
    path: "/fr/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___fr"
  }, {
    path: "/hu/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___hu"
  }, {
    path: "/it/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___it"
  }, {
    path: "/ja/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___ja"
  }, {
    path: "/ko/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___ko"
  }, {
    path: "/nb/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___nb"
  }, {
    path: "/nl/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___nl"
  }, {
    path: "/pl/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___pl"
  }, {
    path: "/pt/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___pt"
  }, {
    path: "/ru/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___ru"
  }, {
    path: "/sv/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___sv"
  }, {
    path: "/th/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___th"
  }, {
    path: "/tr/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___tr"
  }, {
    path: "/zh-hans/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___zh-hans"
  }, {
    path: "/zh-hant/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___zh-hant"
  }, {
    path: "/da/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___da"
  }, {
    path: "/de/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___de"
  }, {
    path: "/es/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___es"
  }, {
    path: "/fr/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___fr"
  }, {
    path: "/hu/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___hu"
  }, {
    path: "/it/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___it"
  }, {
    path: "/ja/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___ja"
  }, {
    path: "/ko/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___ko"
  }, {
    path: "/nb/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___nb"
  }, {
    path: "/nl/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___nl"
  }, {
    path: "/pl/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___pl"
  }, {
    path: "/pt/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___pt"
  }, {
    path: "/ru/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___ru"
  }, {
    path: "/sv/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___sv"
  }, {
    path: "/th/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___th"
  }, {
    path: "/tr/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___tr"
  }, {
    path: "/zh-hans/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___zh-hans"
  }, {
    path: "/zh-hant/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___zh-hant"
  }, {
    path: "/",
    component: _5bed799a,
    name: "index___en"
  }, {
    path: "/:channel",
    component: _da9721a8,
    name: "channel___en"
  }, {
    path: "/:mediaType/categories",
    component: _c6915b98,
    name: "mediaType-categories___en"
  }, {
    path: "/:mediaType/:id",
    component: _4f2240d5,
    name: "mediaType-id___en"
  }, {
    path: "/:mediaType/:id?/:productName",
    component: _fe200ab0,
    name: "mediaType-id-productName___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
